import React from "react";
import "./addUserModal.css";
import { Button, Checkbox, Form, Input, Popconfirm, Select, Typography, Spin } from "antd";
import tickCircle from "../../Assets/img/tickcircle.png";
import { RoleModalVar } from "../../Utils/variables";
import NoDataFound from "../Helpers/NoDataFound";
import CustomTable from "../Table/CustomTable";
import Icon from "@ant-design/icons/lib/components/Icon";
import { useDispatch, useSelector } from "react-redux";
import { trash } from "../../Utils/imports";
import { error } from "../../Helpers/notification";
import moment from "moment";
import { onDeleteValidation, onValidationSubmit } from "../../API-Interaction/apiServices/plantSettings.api";
import { antIcon } from "../../Helpers/helpers";
const { Text } = Typography;
const {
  domain,
  demo,
  submit,
} = RoleModalVar;

const NewValidation = ({ closeModal }) => {

  const { pageLoaders } = useSelector(state => state?.utils.loaders)
  let { validations = null } = useSelector(state => state?.plant?.current?.plant)
  let { plant = null } = useSelector(state => state?.plant?.current)
  let dispatch = useDispatch()

  const onFinishValidation = (values) => {
    validations = [...validations, { value: values.domain }]
    let body = {
      updatedAt: `${moment(Date.now()).format(`YYYY-MM-DDThh:mm:ss.ms`)}Z`,
      validations: validations,
      _id: plant?._id
    }
    onValidationSubmit(dispatch, body)
  };

  const onFinishFailedValidation = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const deleteValidation = (record) => {

    validations = validations.filter(x => x.value != record.value)
    let body = {
      updatedAt: `${moment(Date.now()).format(`YYYY-MM-DDThh:mm:ss.ms`)}Z`,
      validations: validations,
      _id: plant?._id
    }
    onDeleteValidation(dispatch,body)
  }
  return (
    <div>
      <Form
        name="basic"
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishValidation}
        onFinishFailed={onFinishFailedValidation}
        autoComplete="off"
        className="form"
      >
        <label className="b-3">{domain}</label>
        <Form.Item
          name="domain"
          rules={[
            {
              required: true,
              message: "Please input domain name!",
            },
            {
              pattern: new RegExp(/^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
              message: "Enter valid domain name"
            }
          ]}
        >
          <Input className="border" />
        </Form.Item>
        <Spin indicator={antIcon} spinning={pageLoaders?.validation || false}>
          <CustomTable dataSource={validations} columns={[
            {
              title: 'Domains',
              dataIndex: 'value',
              key: 'value',
            },
            {
              title: '',
              dataIndex: 'actions',
              render: (text, record) => {
                return (
                  <>
                    <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { deleteValidation(record) }}>
                      <img src={trash} style={{ width: "15px", cursor: "pointer" }} />
                    </Popconfirm>
                  </>
                );
              },
            },
          ]} />
        </Spin>
        <Form.Item className="btn-align">
          <Button
            className="btn-width dflex alignCenter justifySB gap10"
            type="primary"
            htmlType="submit"
          >
            Add <img src={tickCircle} className="image-icon" />
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default NewValidation;
